import { css } from '@emotion/react'

export const textArea = css`
  max-width: 100% !important;
  min-width: 10rem !important;
`
